/* tslint:disable:variable-name */
const blings_pink = "#FF154D";
const blings_pink__light = "#e23564";
const blings_pink__dark = "#cc3059";
const blings_pink__higlight = "#ff386a";
const blings_pink__accent = "#ff91c5";
const blings_gray1 = "#2e3235";
const blings_dark_gray1 = "#000c17";
const blings_gray_bg1 = "#f0f2f5";
const blings_gray_bg2 = "#cccccc";
const error_red = "#f13636";
const link_blue = "#363ef1";
const blings_chetwode_blue = "#7f95d1";
const blings_mustard_yellow = "#ffd046";
const blings_teal = "#374146";
const blings_teal_80 = "#5F676B";
const blings_teal_60 = "#878D90";
const theme = {
  primary: blings_pink,
  _primary: {
    light: blings_pink__light,
    dark: blings_pink__dark,
    highlight: blings_pink__higlight,
    accent: blings_pink__accent,
  },

  secondary: blings_gray1,
  secondary2: blings_mustard_yellow,
  secondary3: blings_chetwode_blue,
  secondary4: blings_dark_gray1,
  _secondary: {},

  // surface:,
  background: blings_gray_bg1,
  background2: blings_gray_bg2,
  error: error_red,
  link: link_blue,

  //teal:
  teal: blings_teal,
  teal_60: blings_teal_60,
  teal_80: blings_teal_80,
};

//https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less
const antdTheme = {
  "@primary-color": theme.primary, // primary color for all components
  "@info-color": theme.primary,
  "@processing-color": theme.primary,

  "@link-color": theme.link, // link color
  "@success-color": "#52c41a", // success state color
  "@warning-color": "#faad14", // warning state color
  "@error-color": theme.error, // error state color

  "@layout-header-background": theme.secondary,
  "@font-size-base": "14px", // major text font size
  "@heading-color": "rgba(0, 0, 0, 0.85)", // heading text color
  "@text-color": "rgba(0, 0, 0, 0.65)", // major text color
  "@text-color-secondary ": "rgba(0, 0, 0, .45)", // secondary text color
  "@disabled-color ": "rgba(0, 0, 0, .25)", // disable state color

  "@border-radius-base": "4px", // major border radius
  "@border-color-base": "#d9d9d9", // major border color
  "@box-shadow-base": "0 2px 8px rgba(0, 0, 0, 0.15)", // major shadow for layers
};

module.exports = {
  antdTheme,
  theme,
};
